export default class CategoryFilter {
    constructor() {
        this.filterBar = document.querySelector('[data-post-filter]');
        if (!this.filterBar)
            return;
        this.categories = this.filterBar.querySelectorAll('[data-category]');
        this.addEventListeners();
    }
    addEventListeners() {
        this.categories.forEach((category) => {
            category.addEventListener('click', (event) => {
                // set category parameter to url
                const selectedCategory = category.getAttribute('data-category');
                this.toggleCategory(selectedCategory);
            });
        });
    }
    toggleCategory(category) {
        // remove paged from url
        let pathname = window.location.pathname.replace(/\/page\/\d+\/?/, '');
        // new URL
        let newUrl = '';
        if (category === 'all') {
            newUrl = pathname;
        }
        else {
            newUrl = `${pathname}?post_cat=${category}`;
        }
        // Reload
        window.location.href = newUrl;
    }
}
